import * as Firebase from 'firebase/app'
import 'firebase/firestore'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: 'AIzaSyA-ZDIHp3AHAiRoNfvvWIasLrFPyj6bt_U',
  authDomain: 'recreosresiduoscero-cfee4.firebaseapp.com',
  projectId: 'recreosresiduoscero-cfee4',
  storageBucket: 'recreosresiduoscero-cfee4.appspot.com',
  messagingSenderId: '638750440345',
  appId: '1:638750440345:web:0ca78284b1c8d8e5d07108',
  measurementId: 'G-NFXEKM5T4Q'
}

function initFirebase () {
  Firebase.initializeApp(config)
  return new Promise((resolve, reject) => {
    Firebase.firestore().enablePersistence()
      .then(resolve)
      .catch(err => {
        if (err.code === 'failed-precondition') {
          reject(err)
          // Multiple tabs open, persistence can only be
          // enabled in one tab at a a time.
        } else if (err.code === 'unimplemented') {
          reject(err)
          // The current browser does not support all of
          // the features required to enable persistence
        }
      })
  })
}

export { Firebase, initFirebase }
